import styled from 'styled-components';
import { Screens } from 'core/CssVariables';
import { SAuthCard, authCardFormCss } from '../public/authFlow/authFlow.styles';
import {
  AuthFlowColors,
  AuthFlowFont,
} from '../public/authFlow/authFlow.constants';

/** Onboarding uses a wider (640px) card than the 520px auth cards. */
export const SOnboardingCard = styled(SAuthCard)`
  width: 640px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* Tighter than the 32px auth-card padding so the tall form scales up more. */
  padding: 24px;

  ${authCardFormCss}

  /* Fields already have a flex gap; drop the redundant form-item margin so the
     spacing isn't doubled (keeps the tall onboarding form compact). */
  .onb__fields .ant-form-item {
    margin-bottom: 0;
  }

  .onb__header {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .onb__title {
    margin: 0;
    font: 700 24px/24px ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
  }
  .onb__subtitle {
    margin: 0;
    font: 400 16px/24px ${AuthFlowFont};
    color: ${AuthFlowColors.textSecondary};
  }

  .onb__fields {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .onb__row {
    display: flex;
    gap: 16px;
  }
  .onb__row > * {
    flex: 1 1 0;
    min-width: 0;
  }
  /* Per-row delete — fixed size, aligned with the 44px inputs (below labels). */
  .onb__row > .onb__remove {
    flex: 0 0 40px;
    align-self: flex-start;
    margin-top: 24px;
    width: 40px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    color: ${AuthFlowColors.placeholder};
  }
  .onb__row > .onb__remove:hover {
    color: ${AuthFlowColors.error};
  }

  /* Logo upload dropzone */
  .onb__logo {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 16px;
    border-radius: 8px;
    background: ${AuthFlowColors.pageBg};
    border: 2px solid ${AuthFlowColors.heroStroke};
  }
  .onb__logo-text {
    cursor: pointer;
  }
  .onb__logo-title {
    font: 600 14px/16px ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
  }
  .onb__logo-hint {
    font: 400 12px/16px ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
  }
  /* Themed circle for the shared ImageUpload avatar */
  .onb__logo .upload-wrapper {
    border: 1px solid #e9edfb !important;
  }
  .onb__logo .upload-btn {
    width: 64px !important;
    height: 64px !important;
    background: #f7f7f7 !important;
  }

  /* antd Select styled to match the 44px inputs */
  .ant-select {
    width: 100%;
  }
  .ant-select-single .ant-select-selector {
    height: 44px !important;
    padding: 6px 14px !important;
    border-radius: 8px !important;
    border: 1px solid ${AuthFlowColors.cardBorder} !important;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
    display: flex;
    align-items: center;
  }
  .ant-select-single .ant-select-selection-item,
  .ant-select-single .ant-select-selection-placeholder {
    line-height: 30px !important;
    font: 400 14px/30px ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
  }
  .ant-select-single .ant-select-selection-placeholder {
    color: ${AuthFlowColors.placeholder};
  }
  .ant-select-multiple .ant-select-selector {
    min-height: 44px !important;
    border-radius: 8px !important;
    border: 1px solid ${AuthFlowColors.cardBorder} !important;
    padding: 4px 10px !important;
  }
  .ant-select-focused .ant-select-selector {
    border-color: ${AuthFlowColors.navy} !important;
    box-shadow: none !important;
  }

  .onb__divider {
    height: 1px;
    background: ${AuthFlowColors.cardBorder};
    margin: 12px 0;
  }

  .onb__section-title {
    margin: 0;
    font: 700 18px/18px ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
  }
  .onb__section-desc {
    margin: 4px 0 0;
    font: 400 14px/24px ${AuthFlowFont};
    color: ${AuthFlowColors.textSecondary};
  }

  /* "+ Add new user" */
  .onb__add {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 8px 0;
    background: none;
    border: none;
    cursor: pointer;
    font: 600 14px/16px ${AuthFlowFont};
    color: ${AuthFlowColors.link};
  }

  /* Footer button rows */
  .onb__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-top: 16px;
  }
  .onb__footer-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .onb__text-btn {
    padding: 12px 8px;
    background: none;
    border: none;
    cursor: pointer;
    font: 600 16px/24px ${AuthFlowFont};
    color: ${AuthFlowColors.navyText};
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
  .onb__text-btn--muted {
    color: ${AuthFlowColors.placeholder};
  }
  .onb__next {
    flex: 1 1 0;
  }
  .onb__next .ant-btn {
    width: 100%;
  }

  @media (max-width: ${Screens.ScreensMD}) {
    width: 100%;
  }
`;
